<template>
  <div class="reservation">
    <div class="back-btn" @click="$router.push('/reservation')">
      <i class="fas fa-chevron-left"></i>
    </div>
    <div class="columns is-centered">
      <div class="column is-half">
        <div class="logo">
          <img src="/img/agtran_logo.png" alt="">
        </div>
         <div class="header">
           <h2 class="subtitle">Please sign on the area below</h2>
         </div>
      </div>
    </div>
    <div class="columns sign-area">
      <div class="column">
        <VueSignaturePad
          width="100%"
          height="60vh"
          ref="signaturePad"
        />
        <div class="sign-footer">
          <button @click="save" class="button is-primary">Save</button>
          <button @click="undo" class="button is-info">Undo</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { CONFIG } from "../config";
  import { mapState } from 'vuex'

export default {
  data() {
    return {
      signatureFile: new FormData()
    }
  },
  created() {
  },
  methods: {
    undo() {
        this.$refs.signaturePad.undoSignature();
    },
    save() {
      let confirm = window.confirm('Confirm your signature?');
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if(confirm && !isEmpty) {
        let canvas = document.querySelector('canvas');
        let dataUrlImage = this.trimCanvas(canvas);
        let file = this.dataURLtoFile(dataUrlImage);
        this.signatureFile.append('signature', file, 'signature.png');
        this.uploadFile('signature');
      }
      //console.log(isEmpty);
      //console.log(data);
    },
    uploadFile() {
      this.signatureFile.set('code', this.$store.state.reservation.code);
      this.signatureFile.set('ic_num', this.$store.state.reservation.ic_num);

      return this.axios({
        method: 'POST',
        url: CONFIG.api + '/checkin/signature',
        data: this.signatureFile,
        withCredentials: true,
        credentials: 'same-origin',
        headers: {
          Accept: 'multipart/form-data',
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => {
        return this.searchReservation();
      })
      .catch((err) => {
        alert('Something happens. Please refresh and try again.');
      });
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type:mime});
    },
    trimCanvas(c) {
      var ctx = c.getContext('2d'),
        copy = document.createElement('canvas').getContext('2d'),
        pixels = ctx.getImageData(0, 0, c.width, c.height),
        l = pixels.data.length,
        i,
        bound = {
          top: null,
          left: null,
          right: null,
          bottom: null
        },
        x, y;

      for (i = 0; i < l; i += 4) {
        if (pixels.data[i+3] !== 0) {
          x = (i / 4) % c.width;
          y = ~~((i / 4) / c.width);
      
          if (bound.top === null) {
            bound.top = y;
          }
          
          if (bound.left === null) {
            bound.left = x; 
          } else if (x < bound.left) {
            bound.left = x;
          }
          
          if (bound.right === null) {
            bound.right = x; 
          } else if (bound.right < x) {
            bound.right = x;
          }
          
          if (bound.bottom === null) {
            bound.bottom = y;
          } else if (bound.bottom < y) {
            bound.bottom = y;
          }
        }
      }
        
      var trimHeight = bound.bottom - bound.top,
          trimWidth = bound.right - bound.left,
          trimmed = ctx.getImageData(bound.left, bound.top, trimWidth, trimHeight);
      
      copy.canvas.width = trimWidth;
      copy.canvas.height = trimHeight;
      copy.putImageData(trimmed, 0, 0);
      
      // open new window with trimmed image:
      return copy.canvas.toDataURL();
    },
    searchReservation() {
        this.axios({
            url: CONFIG.api + '/checkin',
            method: 'POST',
            data: {
              code: this.reservation.code,
              ic_num: this.reservation.ic_num
            }
          })
          .then((res) => {
            if (res.data.length > 0) {
              this.$store.commit({
                type: 'saveReservation',
                data: res.data[0]
              })
              this.$router.push('/reservation');
            } else {
              alert('Cannot find reservation')
            }
          })
          .catch((err) => {
            console.error(err);
          })
      },
  },
  computed: {
    ...mapState(['reservation']),
  }
}
</script>
<style lang="scss" scoped>
   .reservation {
     padding: 1em;
   }

   .header {
     margin: 0.5em 0 0.5em 0;
     text-align: left;
   }

   .logo {
     margin: 1em 0em 2em 0em;
   }

   .sign-area {
     background: #f0f0f0;

     .sign-footer {
       button {
         margin-right: 0.5em;
       }
       button:last-child {
         margin-right: 0em;
       }
     }
   }

   .back-btn {
     display: flex;
     justify-content: center;
     align-items: center;
     position: absolute;
     font-size: 1em;
     border-radius: 50%;
     width: 2em;
     height: 2em;
     padding: 0.5em;
     line-height: 0;
     color:gray;
   }

</style>
